import {HeadStateActionTypes} from '../../constants/actionType';

export const setTipsPickupPosition = (position) => ({type: HeadStateActionTypes.SET_TIPS_PICKUP_POSITION, position});
export const setTipsPickupLastCalibratedDate = (date) => ({
  type: HeadStateActionTypes.SET_TIPS_PICKUP_POSITION_LAST_CALIBRATED_DATE,
  date,
});
export const setTipsPickupIsRecentlyCalibrated = (isRecentlyCalibrated) => ({
  type: HeadStateActionTypes.SET_TIPS_PICKUP_IS_RECENTLY_CALIBRATED,
  isRecentlyCalibrated,
});

export const resetHeadState = () => ({type: HeadStateActionTypes.RESET_STATE});
